import { BookSize, CoverType } from './types';

/**
 * Card thumbnails use the same pre-cropped assets as the iPhone app
 * (`chatty-ui/Assets/Images.xcassets/book-options-*`).
 *
 * Optional CDN override for production:
 *   REACT_APP_BOOK_OPTIONS_CDN_BASE=https://cdn.chatbooks.com/mk/studio/book-options
 */
const CDN_BASE = process.env.REACT_APP_BOOK_OPTIONS_CDN_BASE?.replace(/\/$/, '');

const asset = (name: string) =>
  CDN_BASE
    ? `${CDN_BASE}/${name}`
    : `${process.env.PUBLIC_URL}/images/book-options/${name}`;

export interface BookOptionsCarouselSlide {
  src: string;
  alt: string;
}

/** Figma book-options carousel (node 5352:8399 / 5378:10368–10395). */
export const BOOK_OPTIONS_CAROUSEL_SLIDES: BookOptionsCarouselSlide[] = [
  {
    src: asset('carousel-1.jpg'),
    alt: 'Chatbooks photo book with a family photo on the cover',
  },
  {
    src: asset('carousel-2.jpg'),
    alt: 'Open Chatbooks photo book showing colorful page layouts',
  },
  {
    src: asset('carousel-3.jpg'),
    alt: 'Side view of a Chatbooks photo book showing page thickness',
  },
  {
    src: asset('carousel-4.jpg'),
    alt: 'Open Chatbooks photo book with collage page layouts',
  },
  {
    src: asset('carousel-5.jpg'),
    alt: 'Stack of Chatbooks photo books in different colors',
  },
  {
    src: asset('carousel-6.jpg'),
    alt: 'Chatbooks photo books shown in 6x6, 8x8, and 10x10 sizes',
  },
];

/** @deprecated Use BOOK_OPTIONS_CAROUSEL_SLIDES[0] — kept for legacy references. */
export const BOOK_OPTIONS_HERO_IMAGE = BOOK_OPTIONS_CAROUSEL_SLIDES[0].src;

export const BOOK_OPTIONS_SELECTIONS_IMAGE =
  'https://cdn.chatbooks.com/mk/studio/studio-book-selections.jpg';

export const BOOK_SIZE_IMAGES: Record<BookSize, string> = {
  '6x6': asset('size-6x6.jpg'),
  '8x8': asset('size-8x8.jpg'),
  '10x10': asset('size-10x10.jpg'),
};

export const COVER_TYPE_IMAGES: Record<CoverType, string> = {
  Softcover: asset('cover-softcover.jpg'),
  Hardcover: asset('cover-hardcover.jpg'),
};

/** Figma crop for the hero lifestyle shot (node 5352:8400). */
export const BOOK_OPTIONS_HERO_CROP = {
  width: '129.79%',
  height: '156.56%',
  left: '-13.52%',
  top: '-36.95%',
};

/** Figma hardcover mockup with static "OUR WEDDING" spine text (node 5352:8478). */
export const BOOK_TITLE_PREVIEW_IMAGE = asset('book-title-preview.jpg');
